export default __webpack_public_path__ + "static/media/FPRM.7a56539a.png";